import { render, staticRenderFns } from "./ShiftSetupNew.vue?vue&type=template&id=8643ce2a"
import script from "./ShiftSetupNew.vue?vue&type=script&lang=js"
export * from "./ShiftSetupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports